import React from 'react';
import PropTypes from 'prop-types';
import StyledButtonBase from './ButtonBase.styled';

const ButtonBase = React.forwardRef(
  (
    {
      children,
      type,
      disabled,
      selected,
      className,
      onClick,
      context,
      ...otherProps
    },
    ref
  ) => (
    <StyledButtonBase
      type={type}
      selected={selected}
      context={context}
      className={className}
      disabled={disabled}
      onClick={onClick}
      disableRipple
      disableFocusRipple
      {...otherProps}
      aria-pressed={selected}
      ref={ref}
    >
      {children}
    </StyledButtonBase>
  )
);

ButtonBase.defaultProps = {
  type: 'secondary',
  disabled: false,
  selected: undefined,
  className: undefined,
  onClick: undefined,
};

ButtonBase.propTypes = {
  type: PropTypes.string,
  context: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

ButtonBase.displayName = 'ButtonBase';

export default React.memo(ButtonBase);
